/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import { take, put, call } from "redux-saga/effects";
import { eventChannel } from "redux-saga";
import {
  GET_ANALYTICS_ADDRESS,
  GET_ANALYTICS_PURPOSE,
  GET_ANALYTICS_BAR,
  GET_TABLE_SOCKET,
  GET_ANA_CARDS,
  GET_CARD
} from "../action/constant";
import { socketUrl } from "../utils/baseUrls";
import { viewerTimeZone } from "../utils/timezone";

function webSocketInitChannel() {
  const data = JSON.parse(localStorage.getItem("building"));
  const buildingId = data || { _id: "", admin: { id: "" } };

  const admin = JSON.parse(localStorage.getItem("adminData"));
  const adminId = admin ? admin._id : "";
  const userType = admin ? admin.type : "";
  // Sent once, on connect. Every getData, card and bar frame the server
  // pushes afterwards is then bucketed into this viewer's days rather than
  // the server's.
  const tz = viewerTimeZone();

  return eventChannel(emit => {
    const socket = new WebSocket(socketUrl);
    socket.onopen = () => {
      socket.send(
        JSON.stringify({
          type: "connect",
          buildingId: `${buildingId._id}`,
          // "_id":`${buildingId.admin._id}`,
          _id: `${adminId}`,
          userType: `${userType}`,
          tz
        })
      );
      socket.send(
        JSON.stringify({
          type: "getData",
          buildingId: `${buildingId._id}`,
          // "_id":`${buildingId.admin.id}`
          _id: `${adminId}`,
          userType: `${userType}`
        })
      );
      socket.send(
        JSON.stringify({
          type: "card",
          buildingId: `${buildingId._id}`,
          // "_id":`${buildingId.admin.id}`
          _id: `${adminId}`,
          userType: `${userType}`
        })
      );
      socket.send(
        JSON.stringify({
          type: "visitor",
          buildingId: `${buildingId._id}`,
          // "_id":`${buildingId.admin.id}`
          _id: `${adminId}`,
          userType: `${userType}`
        })
      );
      setInterval(() => {
        socket.send(
          JSON.stringify({
            type: "ping",
            buildingId: `${buildingId._id}`,
            _id: `${adminId}`,
            userType: `${userType}`
          })
        );
      }, 30000);
      socket.send(
        JSON.stringify({
          type: "nameAddress",
          buildingId: `${buildingId._id}`,
          // "_id":`${buildingId.admin.id}`
          _id: `${adminId}`,
          userType: `${userType}`
        })
      );
      socket.send(
        JSON.stringify({
          type: "bar",
          buildingId: `${buildingId._id}`,
          // "_id":`${buildingId.admin.id}`
          _id: `${adminId}`,
          userType: `${userType}`
        })
      );
      socket.send(
        JSON.stringify({
          type: "graph",
          buildingId: `${buildingId._id}`,
          // "_id":`${buildingId.admin.id}`
          _id: `${adminId}`,
          userType: `${userType}`
        })
      );
    };
    socket.onmessage = e => {
      let msg = null;
      try {
        msg = JSON.parse(e.data);
      } catch {
        socket.close();
      }
      if (msg) {
        const { type } = msg;
        switch (type) {
          case "card":
            return emit({ type: GET_ANA_CARDS.SUCCESS, data: msg.data });
          case "getData":
             return emit({ type: GET_CARD.SUCCESS, data: msg.data });
          case "visitor":
           return emit({ type: GET_TABLE_SOCKET.SUCCESS, data: msg.visitors });
          case "nameAddress":
         return emit({ type: GET_ANALYTICS_ADDRESS.SUCCESS, data: msg.data });
          case "bar":
            return emit({ type: GET_ANALYTICS_BAR.SUCCESS, data: msg.data });
          case "graph":
            return emit({ type: GET_ANALYTICS_PURPOSE.SUCCESS, data: msg.data });

          default:
            break;
        }
      }
    };
    return () => {
      socket.onClose();
    };
  });
}
export default function* vmsSocketSaga() {
  const channel = yield call(webSocketInitChannel);

  while (true) {
    try {
      const action = yield take(channel);
      yield put(action);
    } catch {
      channel.close();
    }
  }
}

// export default function* vmsSocketWatcherSaga(){
//   yield takeLatest({type:'CONNECT_SOCKET'},vmsSocketSaga);
// }
